<template>
  <vs-table v-if="show" ref="table" :params="params" ></vs-table>
</template>

<script>
  import VsTable from "../../_framework/VsTable.vue";
  export default {
    name: "users",
    components: {
      VsTable
    },
    data() {
      return {
        access: {},
        show: true,
        params: {
          entity: "users",
          list: [],
          headers: {
            UserCode: {
              title: "کد شخص",
              type: "text"
            },
            companyName: {
              title: "شرکت / نام خانوادگی",
              type: "text"
            },
            Name: {
              title: "نام",
              type: "text"
            },

          PersonalityType: {
              title: "نوع شخصیت",
              type: "text"
            },
            Group: {
              title: "گروه",
              type: "text"
            },
            Phone: {
              title: "تلفن",
              type: "text"
            },
            Mobile: {
              title: "موبایل",
              type: "text"
            },
            NationalNumber: {
              title: "شماره ملی",
              type: "text"
            },

            EconomicCode: {
              title: "کد اقتصادی",
              type: "text"
            },

          }
        },

      };
    },

  };
</script>

<style scoped>

</style>
